import React from 'react'
import ContactFormComponent from 'components/ContactFormComponent'

class ContactComponent extends React.Component {
  render() {
    const { language } = this.props
    let headerText = 'SCHREIBEN SIE UNS JETZT…'
    let subText = 'Erzählen Sie uns von Ihrem Projekt, wo Sie Unterstützung benötigen und wir rufen Sie gerne zurück. Wir freuen uns auf Ihre Nachricht!'
    if (language==='en') {
      headerText = 'SEND US A MESSAGE…'
      subText = 'Tell us about your project, how we can help you and how to reach you. We are looking forward to hear from you!'
    }
    return (
      <div id="contact" className="contactform-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12 section-heading text-center">
              <span className="h2"><b>{headerText}</b></span>
              <div className="row">
                <div className="col-md-6 col-md-offset-3">
                  <span className="h3">{subText}</span>
                  <ContactFormComponent
                    language={language}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ContactComponent



// WEBPACK FOOTER //
// ./src/components/ContactComponent/index.js